'use client';

import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '@/lib/utils';
// import Flare from "@/components/global/ui/Flare"

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(
  (
    { className, children, align = 'center', sideOffset = 4, ...props },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-[9999] w-72 rounded-md border-none bg-black/80 p-0 text-white shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]',
          className,
        )}
        {...props}
      >
        <div className="bg-black rounded-[0.5rem] overflow-clip">
          <div className="bg-[radial-gradient(68.02%_88.02%_at_50%_0%,_rgba(107,158,189,0.2)_0%,_rgba(107,158,189,0)_100%)] rounded-[1.5rem]">
            <div className="relative bg-black bg-opacity-[.07] rounded-[1.5rem] gradient-border-lb">
              <div className="relative p-1 bg-white bg-opacity-[.06] rounded-[1.5rem] backdrop-blur-[2rem]">
                {/* <Flare className="!w-[80rem] opacity-[.25] top-0 left-1/2 -translate-x-1/2 -translate-y-1/2" /> */}
                {children}
              </div>
            </div>
          </div>
        </div>
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
